import React, { useEffect } from 'react';
import { Navigate } from 'react-router';

import { useIsMobile } from '#/hooks/useIsMobile';
import { skipDesktopQRConnectModal } from '#/reduxState/exchange/userGuideReducer';
import { staticDispatch, useSelector } from '#/reduxState/store';
import {
  showDesktopQRConnectModal,
  showWalletModal,
} from '#/reduxState/wallet/walletDetailsReducer';

/**
 * Automatically trigger share QR code functionality.
 * It can also include Wallet unlock if needed.
 *
 * Used on the landing page link.
 */
export function AutomaticKatanaConnectPageWithRedirect() {
  useAutomaticQrShareModal();
  return <Navigate to="/wallet/positions" />;
}

function useAutomaticQrShareModal() {
  const isMobile = useIsMobile();
  const walletAddress = useSelector(state => state.wallet.walletAddress);
  const skipDesktopQrConnectModal = useSelector(
    state => state.exchange.userGuide.skipQrConnectModal
  );

  useEffect(() => {
    if (!isMobile) {
      return;
    }
    // Mobile auto-unlock by scanning QR
    staticDispatch(
      showWalletModal({
        preSelect: {
          remember: true,
          walletType: 'qrSynced',
        },
        afterGoTo: '/',
        keepWalletUntilSuccess: false,
      })
    );
  }, [isMobile]);

  useEffect(() => {
    if (isMobile) {
      return;
    }
    // Mobile auto-generate QR code
    if (walletAddress) {
      staticDispatch(showDesktopQRConnectModal('withoutDoNotShowAgain'));
    } else {
      if (skipDesktopQrConnectModal) {
        staticDispatch(skipDesktopQRConnectModal(false));
      }
      staticDispatch(showWalletModal());
    }
    // routerHistory.replace(window.location.pathname);
  }, [isMobile, skipDesktopQrConnectModal, walletAddress]);
}
